// extracted by mini-css-extract-plugin
export default {"containerVerticalBar":"VerticalBar_containerVerticalBar__g8BAM","containerHorizontalBar":"VerticalBar_containerHorizontalBar__IIHuu"};